import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthState, User } from '../../types/auth';
import { tokenStorage } from '../../utils/tokenStorage';

const initialState: AuthState = {
  user: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    loginSuccess: (state, action: PayloadAction<{ user: User }>) => {
      state.isLoading = false;
      state.user = action.payload.user;
      state.isAuthenticated = true;
      state.error = null;
    },
    loginFailure: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
      state.isAuthenticated = false;
      state.user = null;
    },
    logout: (state) => {
      // CRITICAL SECURITY: All API caches are cleared by logoutMiddleware BEFORE this action
      // This prevents data leakage between users
      state.user = null;
      state.isAuthenticated = false;
      state.error = null;
      
      // Clear token storage
      tokenStorage.clearTokenData();
    },
    updateUserProfile: (state, action: PayloadAction<Partial<User>>) => {
      // Update user profile data (e.g., hasClients flag)
      if (state.user) {
        state.user = { ...state.user, ...action.payload };
      }
    },
    initializeAuth: (state) => {
      const tokenData = tokenStorage.getTokenData();
      const userData = tokenStorage.getUserData();
      
      if (tokenData && userData && tokenStorage.isTokenValid()) {
        state.user = userData.user;
        state.isAuthenticated = true;
      } else {
        // Clear invalid/expired data
        tokenStorage.clearTokenData();
        state.user = null;
        state.isAuthenticated = false;
      }
    },
  },
});

// Helper functions are now in tokenStorage utility

export const { loginStart, loginSuccess, loginFailure, logout, initializeAuth, updateUserProfile } = authSlice.actions;
export default authSlice.reducer;